import { FakePostcodeCheckerUI } from "./FakePostcodeCheckerUI";
import { StandardProps } from "../componentMap";
import cookies from "js-cookie";
import { useEffect, useState } from "react";

function getEnvironment(monetateEnvironment: string): string {
  if (!monetateEnvironment) {
    return "integration.project4.com";
  }
  if (monetateEnvironment.indexOf("dev") != -1) {
    return "integration.project4.com";
  }

  return "johnlewis.com";
}

export function FakePostcodeChecker({
  runtimeConfig,
  experiences,
}: Pick<StandardProps, "runtimeConfig" | "experiences">) {
  const [showPostcodeChecker, setShowPostcodeChecker] = useState(
    experiences?.showPostcodeChecker != undefined &&
      experiences?.showPostcodeChecker === "true"
      ? true
      : false,
  );

  const monetateEnvironment = runtimeConfig?.monetateEnvironment || "";

  const environment = getEnvironment(monetateEnvironment);

  useEffect(() => {
    if (experiences?.showPostcodeChecker) {
      setShowPostcodeChecker(cookies.get("postcodepainteddoor") ? false : true);
    }
  }, [experiences]);

  if (!showPostcodeChecker) {
    return null;
  }
  return <FakePostcodeCheckerUI domain={environment} />;
}
